const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');


const Expandable = ({ children, className, ...props }) => (
    <aside className={classNames('vertical-accordion', className)} {...props}>
        {children}
    </aside>
);


Expandable.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    viewIndex: PropTypes.number,
};


module.exports = Expandable;
